import React, { useEffect, useState } from "react";

import AOS from "aos";
import "aos/dist/aos.css";
import "../../css/Mirissa.css";

import { storage } from "../../firebase";
import { ref, getDownloadURL } from "firebase/storage";

function Polonnaruwa() {

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const [imgHero, setImgHero] = useState("");

  // TOP GALLERY
  const [polonnaruwa1, setPolonnaruwa1] = useState("");
  const [polonnaruwa2, setPolonnaruwa2] = useState("");

  // EXTRA GALLERY
  const [polonnaruwa3, setPolonnaruwa3] = useState("");
  const [polonnaruwa4, setPolonnaruwa4] = useState("");
  const [polonnaruwa5, setPolonnaruwa5] = useState("");

  // ACTIVITIES IMAGES
  const [galWiharaya, setGalWiharaya] = useState("");
  const [sandakadaPahana, setSandakadaPahana] = useState("");
  const [galpotha, setGalpotha] = useState("");

  const [parakramaSamudra, setParakramaSamudra] = useState("");
  const [parakramaSystem, setParakramaSystem] = useState("");
  const [lotusPond, setLotusPond] = useState("");

  const [nataraja, setNataraja] = useState("");
  const [woodCrafts, setWoodCrafts] = useState("");
  const [artsCrafts, setArtsCrafts] = useState("");

  // PARROT ROCK SECTION
  const [polonnaruwa6, setPolonnaruwa6] = useState("");
  const [polonnaruwa7, setPolonnaruwa7] = useState("");

  useEffect(() => {

    getDownloadURL(ref(storage, "polonnaruwa-hero.jpg")).then(setImgHero);

    // TOP GALLERY
    getDownloadURL(ref(storage, "polonnaruwa1.jpg")).then(setPolonnaruwa1);
    getDownloadURL(ref(storage, "polonnaruwa2.jpg")).then(setPolonnaruwa2);

    // EXTRA GALLERY
    getDownloadURL(ref(storage, "polonnaruwa3.jpg")).then(setPolonnaruwa3);
    getDownloadURL(ref(storage, "polonnaruwa4.jpg")).then(setPolonnaruwa4);
    getDownloadURL(ref(storage, "polonnaruwa5.jpg")).then(setPolonnaruwa5);

    // ACTIVITIES (ANCIENT CITY)
    getDownloadURL(ref(storage, "Gal Wiharaya.png")).then(setGalWiharaya);
    getDownloadURL(ref(storage, "Sandakada Pahana.png")).then(setSandakadaPahana);
    getDownloadURL(ref(storage, "Galpoth (Rock Book).png")).then(setGalpotha);

    // IRRIGATION
    getDownloadURL(ref(storage, "Parakrama Samudra.png")).then(setParakramaSamudra);
    getDownloadURL(ref(storage, "Parakrama Samudra irrigation system.png")).then(setParakramaSystem);
    getDownloadURL(ref(storage, "Lotus Pond.png")).then(setLotusPond);

    // CRAFTS
    getDownloadURL(ref(storage, "Nataraja Statue.png")).then(setNataraja);
    getDownloadURL(ref(storage, "Wooden Crafts.png")).then(setWoodCrafts);
    getDownloadURL(ref(storage, "Arts and crafts.png")).then(setArtsCrafts);

    // PARROT ROCK SECTION
    getDownloadURL(ref(storage, "polonnaruwa6.jpg")).then(setPolonnaruwa6);
    getDownloadURL(ref(storage, "polonnaruwa7.jpg")).then(setPolonnaruwa7);
  }, []);

  return (
    <div className="destination-container">
      {/* HERO SECTION */}
      <section
        className="mirissa-hero"
        style={{ backgroundImage: `url(${imgHero})` }}
        data-aos="fade-down"
      >
        <div className="overlay">
          <h1>Polonnaruwa</h1>
        </div>
      </section>

      {/* MAIN CONTENT */}
      <section className="mirissa-container">

        {/* LEFT CONTENT */}
        <div className="mirissa-left" data-aos="fade-right">

          <h2>Polonnaruwa</h2>
          <p>
            UNESCO World Heritage with rich exploration of history, culture, and ancient architecture.
          </p>

          <p>
            The cultural triangle of Sri Lanka connects three cities: Anuradhapura, Polonnaruwa, and Kandy.
            This cultural triangle contains numerous historical and ancient sites.
            Polonnaruwa is an ancient city that is considered one of the eight UNESCO World Heritage Sites in Sri Lanka.
          </p>

          <div className="mirissa-gallery">
            <img src={polonnaruwa1} alt="Polonnaruwa View" />
            <img src={polonnaruwa2} alt="Polonnaruwa Temple" />
          </div>

          <p>
            It was recognized as the second oldest city in Sri Lanka, right after Anuradhapura.
            Polonnaruwa was a kingdom in the history of Sri Lanka that was ruled and administered by many kings.
            The two kingdoms differ mainly in that, unlike the kingdom of Anuradhapura,
            the kingdom of Polonnaruwa was influenced by many Hindu elements and was even ruled by some Tamil kings.
            This cultural city, in addition to Buddhist temples, also has many Hindu temples.
            This city is also known for its agriculture. There are many farmers.
          </p>

          <h3>Places to visit in Polonnaruwa</h3>

          <ul className="mirissa-list">
            <li>Ancient Ruins of the Royal Palace of King Parakramabahu</li>
            <li>Gal Vihara</li>
            <li>Lankatilaka Temple</li>
            <li>Lankarama</li>
            <li>Thuparama</li>
            <li>Pothgul Vihara</li>
            <li>Galpotha (Stone Book)</li>
            <li>Parakrama Samudra</li>
            <li>Local Markets and Craft Shops</li>
          </ul>

          {/* EXTRA CONTENT FROM SCREENSHOT */}
          <div className="mirissa-extra" data-aos="fade-up">

            <div className="mirissa-top-gallery">
              <img src={polonnaruwa3} alt="Image 1" />
              <img src={polonnaruwa4} alt="Image 2" />
              <img src={polonnaruwa5} alt="Image 3" />
            </div>

            <h3>Most of the tourists and visitors come to this place through Mirissa beach.</h3>

            <p>
              In Polonnaruwa, an important place is the ancient ruins of the royal palace of King Parakramabahu.
              Although you can see the ruins, they are a testament to great architecture and design.
            </p>

            <p>
              Another main attraction is "Galvihara," which consists of numerous beautiful Buddha statues and sculptures.
              It is a symbol of exceptional sculptural art. Additionally, in the city, there are several very important temples,
              stupas, and religious places, such as Lankatilaka Temple, Lankarama, Tupparamaya, and Pothgul Vihara.Galpota.
              Great Buddhist temple that reflects the religious importance of Polonnaruwa.
            </p>

            <p>
              Parakrama Bahu Samudra: Enjoy the peaceful view and learn about the ancient irrigation system.
              Great artificial reservoir, built by King Parakramabahu.
            </p>

            <p>
              Local markets or craft shops: Local markets or craft shops: End the day by visiting the souvenir shops and food stalls in the city of Polonnaruwa.
            </p>

            <p>
              Beautiful Sri Lanka, beautiful Polonnaruwa. You can include polonnaruwa in your tour itinerary.
              which consists of very informative and educational. On this day,
              you will learn about the various influences that the kingdom of Polonnaruwa has undergone,
              the names of the rulers, and the impact of agriculture.
              This is the perfect day trip for anyone who loves discovering new cultures and exploring history.
              Sri Lanka, in general, has a very rich history in the realms of kingdoms,
              agriculture, and civilization.This is about 4 to 5 hour tour.
            </p>

          </div>

          {/* ACTIVITIES SECTION */}
          <div className="mirissa-activities" data-aos="fade-up">

            <details className="activity-box" open>
              <summary>• Ancient Ruins of Second Capital in Sri Lanka</summary>

              <p>
                Polonnaruwa, the second capital of Sri Lanka, boasts magnificent ancient ruins, including King Parakramabahu's royal palace.
                These remnants highlight impressive architecture and cultural influence from both Buddhist and Hindu traditions,
                reflecting the city's historical significance and its role as a flourishing kingdom in Sri Lanka's rich heritage.
              </p>

              <div className="activity-gallery">
                <div className="activity-gallery">
                  <div className="activity-card">
                    <img src={galWiharaya} alt="Gal Wiharaya" />
                    <p>Gal Wiharaya</p>
                  </div>

                  <div className="activity-card">
                    <img src={sandakadaPahana} alt="Sandakada Pahana" />
                    <p>Sandakada Pahana</p>
                  </div>

                  <div className="activity-card">
                    <img src={galpotha} alt="Galpotha" />
                    <p>Galpoth (Rock Book)</p>
                  </div>
                </div>
              </div>
            </details>

            <details className="activity-box">
              <summary>• Irrigation System in Ancient Sri Lanka</summary>

              <p>
                Polonnaruwa showcases the ingenuity of ancient Sri Lankan engineering through its irrigation marvels.
                The Parakrama Samudra, a massive reservoir, demonstrates advanced water management techniques that supported agriculture and sustained the kingdom,
                symbolizing King Parakramabahu's vision that 'not even a drop of water should flow into the ocean unused.'
              </p>

              <div className="activity-gallery">
                <div className="activity-card">
                  <img src={parakramaSamudra} alt="Parakrama Samudra" />
                  <p>Parakrama Samudra</p>
                </div>

                <div className="activity-card">
                  <img src={parakramaSystem} alt="Irrigation system" />
                  <p>Parakrama Samudra irrigation system</p>
                </div>

                <div className="activity-card">
                  <img src={lotusPond} alt="Lotus Pond" />
                  <p>Lotus Pond</p>
                </div>
              </div>
            </details>

            <details className="activity-box">
              <summary>• Local Hand Made Crafts</summary>

              <p>
                Polonnaruwa’s vibrant local markets offer unique handmade crafts that reflect the region's cultural richness.
                Traditional carvings, woven goods, and pottery exemplify the artisans' skills,
                providing visitors with beautiful souvenirs while supporting the preservation of Sri Lanka's artisanal heritage and showcasing its diverse cultural traditions.
              </p>

              <div className="activity-gallery">
                <div className="activity-card">
                  <img src={nataraja} alt="Nataraja" />
                  <p>Nataraja Statue</p>
                </div>

                <div className="activity-card">
                  <img src={woodCrafts} alt="Wood Crafts" />
                  <p>Wooden Crafts</p>
                </div>

                <div className="activity-card">
                  <img src={artsCrafts} alt="Arts and Crafts" />
                  <p>Arts and crafts</p>
                </div>
              </div>
            </details>
          </div>

          {/* PARROT ROCK SECTION */}
          <div className="mirissa-parrot-rock" data-aos="fade-up">

            <div className="parrot-gallery">
              <img src={polonnaruwa6} alt="Polonnaruwa Lake" />
              <img src={polonnaruwa7} alt="Polonnaruwa Village" />
            </div>

          </div>

        </div>

        {/* RIGHT INQUIRY FORM */}
        <div className="mirissa-form" data-aos="fade-left">
          <h3>Make an Inquiry</h3>

          <form
            onSubmit={(e) => {
              e.preventDefault();

              const name = e.target.name.value;
              const email = e.target.email.value;
              const country = e.target.country.value;
              const code = e.target.code.value;
              const phone = e.target.phone.value;
              const arrival = e.target.arrival.value;
              const departure = e.target.departure.value;
              const interest = e.target.interest.value;
              const vehicle = e.target.vehicle.value;   // ✅ NEW
              const adults = e.target.adults.value;
              const kids = e.target.kids.value;
              const message = e.target.message.value;

              const fullMessage = `
                📌 NEW TOUR BOOKING

                👤 Name: ${name}
                📧 Email: ${email}
                🌍 Country: ${country}
                📞 Phone: ${code} ${phone}
                📅 Arrival: ${arrival}
                📅 Departure: ${departure}
                🎯 Interest: ${interest}
                🚗 Vehicle Preference: ${vehicle}
                👨‍👩‍👧 Adults: ${adults}
                🧒 Kids: ${kids}

                💬 Message: ${message} 
              `;

              // ✅ SEND WHATSAPP
              const whatsappNumber = "94717726099"; // your WhatsApp number
              const whatsappURL =
                "https://wa.me/" + whatsappNumber + "?text=" + encodeURIComponent(fullMessage);

              window.open(whatsappURL, "_blank");

              // ✅ SEND EMAIL
              const mailto =
                "mailto:ceylongracetravels@gmail.com" +
                "?subject=" + encodeURIComponent("New Tour Booking") +
                "&body=" + encodeURIComponent(fullMessage);

              window.location.href = mailto;

              alert("✅ Your Booking is Send!");
            }}
          >
            <input name="name" type="text" placeholder="Name *" />
            <input name="email" type="email" placeholder="Email Address *" />

            <select name="country" required>
              <option value="">Choose Your Country *</option>
              <option value="Afghanistan">Afghanistan</option>
              <option value="Albania">Albania</option>
              <option value="Algeria">Algeria</option>
              <option value="Andorra">Andorra</option>
              <option value="Angola">Angola</option>
              <option value="Antigua and Barbuda">Antigua and Barbuda</option>
              <option value="Argentina">Argentina</option>
              <option value="Armenia">Armenia</option>
              <option value="Australia">Australia</option>
              <option value="Austria">Austria</option>
              <option value="Azerbaijan">Azerbaijan</option>
              <option value="Bahamas">Bahamas</option>
              <option value="Bahrain">Bahrain</option>
              <option value="Bangladesh">Bangladesh</option>
              <option value="Barbados">Barbados</option>
              <option value="Belarus">Belarus</option>
              <option value="Belgium">Belgium</option>
              <option value="Belize">Belize</option>
              <option value="Benin">Benin</option>
              <option value="Bhutan">Bhutan</option>
              <option value="Bolivia">Bolivia</option>
              <option value="Bosnia and Herzegovina">Bosnia and Herzegovina</option>
              <option value="Botswana">Botswana</option>
              <option value="Brazil">Brazil</option>
              <option value="Brunei">Brunei</option>
              <option value="Bulgaria">Bulgaria</option>
              <option value="Burkina Faso">Burkina Faso</option>
              <option value="Burundi">Burundi</option>
              <option value="Cabo Verde">Cabo Verde</option>
              <option value="Cambodia">Cambodia</option>
              <option value="Cameroon">Cameroon</option>
              <option value="Canada">Canada</option>
              <option value="Central African Republic">Central African Republic</option>
              <option value="Chad">Chad</option>
              <option value="Chile">Chile</option>
              <option value="China">China</option>
              <option value="Colombia">Colombia</option>
              <option value="Comoros">Comoros</option>
              <option value="Congo, Democratic Republic of the">Congo, Democratic Republic of the</option>
              <option value="Congo, Republic of the">Congo, Republic of the</option>
              <option value="Costa Rica">Costa Rica</option>
              <option value="Côte d’Ivoire">Côte d’Ivoire</option>
              <option value="Croatia">Croatia</option>
              <option value="Cuba">Cuba</option>
              <option value="Cyprus">Cyprus</option>
              <option value="Czech Republic">Czech Republic</option>
              <option value="Denmark">Denmark</option>
              <option value="Djibouti">Djibouti</option>
              <option value="Dominica">Dominica</option>
              <option value="Dominican Republic">Dominican Republic</option>
              <option value="Ecuador">Ecuador</option>
              <option value="Egypt">Egypt</option>
              <option value="El Salvador">El Salvador</option>
              <option value="Equatorial Guinea">Equatorial Guinea</option>
              <option value="Eritrea">Eritrea</option>
              <option value="Estonia">Estonia</option>
              <option value="Eswatini">Eswatini</option>
              <option value="Ethiopia">Ethiopia</option>
              <option value="Fiji">Fiji</option>
              <option value="Finland">Finland</option>
              <option value="France">France</option>
              <option value="Gabon">Gabon</option>
              <option value="Gambia">Gambia</option>
              <option value="Georgia">Georgia</option>
              <option value="Germany">Germany</option>
              <option value="Ghana">Ghana</option>
              <option value="Greece">Greece</option>
              <option value="Grenada">Grenada</option>
              <option value="Guatemala">Guatemala</option>
              <option value="Guinea">Guinea</option>
              <option value="Guinea-Bissau">Guinea-Bissau</option>
              <option value="Guyana">Guyana</option>
              <option value="Haiti">Haiti</option>
              <option value="Honduras">Honduras</option>
              <option value="Hungary">Hungary</option>
              <option value="Iceland">Iceland</option>
              <option value="India">India</option>
              <option value="Indonesia">Indonesia</option>
              <option value="Iran">Iran</option>
              <option value="Iraq">Iraq</option>
              <option value="Ireland">Ireland</option>
              <option value="Israel">Israel</option>
              <option value="Italy">Italy</option>
              <option value="Jamaica">Jamaica</option>
              <option value="Japan">Japan</option>
              <option value="Jordan">Jordan</option>
              <option value="Kazakhstan">Kazakhstan</option>
              <option value="Kenya">Kenya</option>
              <option value="Kiribati">Kiribati</option>
              <option value="Korea, North">Korea, North</option>
              <option value="Korea, South">Korea, South</option>
              <option value="Kuwait">Kuwait</option>
              <option value="Kyrgyzstan">Kyrgyzstan</option>
              <option value="Laos">Laos</option>
              <option value="Latvia">Latvia</option>
              <option value="Lebanon">Lebanon</option>
              <option value="Lesotho">Lesotho</option>
              <option value="Liberia">Liberia</option>
              <option value="Libya">Libya</option>
              <option value="Liechtenstein">Liechtenstein</option>
              <option value="Lithuania">Lithuania</option>
              <option value="Luxembourg">Luxembourg</option>
              <option value="Madagascar">Madagascar</option>
              <option value="Malawi">Malawi</option>
              <option value="Malaysia">Malaysia</option>
              <option value="Maldives">Maldives</option>
              <option value="Mali">Mali</option>
              <option value="Malta">Malta</option>
              <option value="Marshall Islands">Marshall Islands</option>
              <option value="Mauritania">Mauritania</option>
              <option value="Mauritius">Mauritius</option>
              <option value="Mexico">Mexico</option>
              <option value="Micronesia">Micronesia</option>
              <option value="Moldova">Moldova</option>
              <option value="Monaco">Monaco</option>
              <option value="Mongolia">Mongolia</option>
              <option value="Montenegro">Montenegro</option>
              <option value="Morocco">Morocco</option>
              <option value="Mozambique">Mozambique</option>
              <option value="Myanmar (Burma)">Myanmar (Burma)</option>
              <option value="Namibia">Namibia</option>
              <option value="Nauru">Nauru</option>
              <option value="Nepal">Nepal</option>
              <option value="Netherlands">Netherlands</option>
              <option value="New Zealand">New Zealand</option>
              <option value="Nicaragua">Nicaragua</option>
              <option value="Niger">Niger</option>
              <option value="Nigeria">Nigeria</option>
              <option value="North Macedonia">North Macedonia</option>
              <option value="Norway">Norway</option>
              <option value="Oman">Oman</option>
              <option value="Pakistan">Pakistan</option>
              <option value="Palau">Palau</option>
              <option value="Panama">Panama</option>
              <option value="Papua New Guinea">Papua New Guinea</option>
              <option value="Paraguay">Paraguay</option>
              <option value="Peru">Peru</option>
              <option value="Philippines">Philippines</option>
              <option value="Poland">Poland</option>
              <option value="Portugal">Portugal</option>
              <option value="Qatar">Qatar</option>
              <option value="Romania">Romania</option>
              <option value="Russia">Russia</option>
              <option value="Rwanda">Rwanda</option>
              <option value="Saint Kitts and Nevis">Saint Kitts and Nevis</option>
              <option value="Saint Lucia">Saint Lucia</option>
              <option value="Saint Vincent and the Grenadines">Saint Vincent and the Grenadines</option>
              <option value="Samoa">Samoa</option>
              <option value="San Marino">San Marino</option>
              <option value="Sao Tome and Principe">Sao Tome and Principe</option>
              <option value="Saudi Arabia">Saudi Arabia</option>
              <option value="Senegal">Senegal</option>
              <option value="Serbia">Serbia</option>
              <option value="Seychelles">Seychelles</option>
              <option value="Sierra Leone">Sierra Leone</option>
              <option value="Singapore">Singapore</option>
              <option value="Slovakia">Slovakia</option>
              <option value="Slovenia">Slovenia</option>
              <option value="Solomon Islands">Solomon Islands</option>
              <option value="Somalia">Somalia</option>
              <option value="South Africa">South Africa</option>
              <option value="South Sudan">South Sudan</option>
              <option value="Spain">Spain</option>
              <option value="Sri Lanka">Sri Lanka</option>
              <option value="Sudan">Sudan</option>
              <option value="Suriname">Suriname</option>
              <option value="Sweden">Sweden</option>
              <option value="Switzerland">Switzerland</option>
              <option value="Syria">Syria</option>
              <option value="Taiwan">Taiwan</option>
              <option value="Tajikistan">Tajikistan</option>
              <option value="Tanzania">Tanzania</option>
              <option value="Thailand">Thailand</option>
              <option value="Timor-Leste">Timor-Leste</option>
              <option value="Togo">Togo</option>
              <option value="Tonga">Tonga</option>
              <option value="Trinidad and Tobago">Trinidad and Tobago</option>
              <option value="Tunisia">Tunisia</option>
              <option value="Turkey">Turkey</option>
              <option value="Turkmenistan">Turkmenistan</option>
              <option value="Tuvalu">Tuvalu</option>
              <option value="Uganda">Uganda</option>
              <option value="Ukraine">Ukraine</option>
              <option value="United Arab Emirates">United Arab Emirates</option>
              <option value="United Kingdom">United Kingdom</option>
              <option value="United States">United States</option>
              <option value="Uruguay">Uruguay</option>
              <option value="Uzbekistan">Uzbekistan</option>
              <option value="Vanuatu">Vanuatu</option>
              <option value="Vatican City">Vatican City</option>
              <option value="Venezuela">Venezuela</option>
              <option value="Vietnam">Vietnam</option>
              <option value="Yemen">Yemen</option>
              <option value="Zambia">Zambia</option>
              <option value="Zimbabwe">Zimbabwe</option>
            </select>

            <div className="phone-row">
              <input name="code" className="code" type="text" placeholder="Code" />
              <input name="phone" className="phone" type="text" placeholder="Phone Number *" />
            </div>

            <label htmlFor="arrival">Arrival Date</label>
            <input name="arrival" type="date" />

            <label htmlFor="departure">Departure Date</label>
            <input name="departure" type="date" />

            <select name="interest">
              <option value="">Choose Your Interest *</option>
              <option value="Eco">Eco</option>
              <option value="Beach">Beach</option>
              <option value="Cultural">Cultural</option>
              <option value="Adventure">Adventure</option>
              <option value="Wild Life">Wild Life</option>
              <option value="Relax and Wellness">Relax and Wellness</option>
              <option value="Honeymoon">Honeymoon</option>
              <option value="Ramayana Trail">Ramayana Trail</option>
              <option value="All in one Trails">All in one Trails</option>
            </select>

            <select name="vehicle">
              <option value="">Select Vehicle Type *</option>
              <option value="Sedan – Toyota Prius (3 Pax)">Sedan – Toyota Prius (3 Pax)</option>
              <option value="Sedan – Toyota Axio (3 Pax)">Sedan – Toyota Axio (3 Pax)</option>
              <option value="Sedan – Honda Grace (3 Pax)">Sedan – Honda Grace (3 Pax)</option>
              <option value="Mini – Suzuki Wagon R (2 Pax)">Mini – Suzuki Wagon R (2 Pax)</option>
              <option value="Mini – Toyota Aqua (2 Pax)">Mini – Toyota Aqua (2 Pax)</option>
              <option value="Van – Suzuki Every (4 Pax)">Van – Suzuki Every (4 Pax)</option>
              <option value="Van – Mini Van (4 Pax)">Van – Mini Van (4 Pax)</option>
              <option value="Van – Toyota Noha (4 Pax)">Van – Toyota Noha (4 Pax)</option>
              <option value="Bus – Mitsubishi Rosa (12 Pax)">Bus – Mitsubishi Rosa (12 Pax)</option>
              <option value="Bus – King Long (12 Pax)">Bus – King Long (12 Pax)</option>
            </select>

            <input name="adults" type="number" placeholder="Adults *" />
            <input name="kids" type="number" placeholder="Kids" />

            <textarea name="message" placeholder="Enter your message"></textarea>

            <button type="submit">SUBMIT</button>
          </form>

        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section" data-aos="fade-up">
        <div className="cta-box">
          <div className="cta-left">
            <img src={require("../../assets/hile.png")} className="cta-icon" alt="icon" />
            <div className="cta-text">
              <h2>Ready To Adventure And Enjoy Natural</h2>
              <p>Reach Ceylon Grace Travels For A Secure, Luxurious, And Unforgettable Adventure!</p>
            </div>
          </div>

          <img src={require("../../assets/plan.png")} className="cta-plane" alt="plane" />

          <button className="cta-btn">LET’S GET STARTED</button>
        </div>
      </section>
    </div>
  );
}

export default Polonnaruwa;
